module.exports = __webpack_public_path__ + "img/backgroundImg.6a4ebaed.jpg";